// extracted by mini-css-extract-plugin
export var root = "Logo-module--root--3n0Kq";
export var logoLabel = "Logo-module--logoLabel--3aKvM";
export var logo = "Logo-module--logo--356yT";